
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $8cdb3847efa763dd$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"izUj7\",\"index.4f25e4fc.js\",\"1dPKL\",\"robogebra-footer-logo.f097702f.svg\",\"g3GYT\",\"scroll-to-top.defda773.svg\",\"a2AIa\",\"sampleimage2.01db026e.png\",\"egcF3\",\"solutionimage11.01cbdfe5.png\",\"dEtie\",\"solutionimage12.bf3a34c2.png\",\"7x1Cz\",\"solutionimage5.e15e4d12.png\",\"4C5K8\",\"robogebra-og.397d41ee.png\"]"));

var $b3773c591ac0eb42$exports = {};
$b3773c591ac0eb42$exports = new URL("robogebra-footer-logo.f097702f.svg", import.meta.url).toString();


var $4cfeafcf552783b9$exports = {};
$4cfeafcf552783b9$exports = new URL("scroll-to-top.defda773.svg", import.meta.url).toString();


var $ed4aa2874a289849$exports = {};
$ed4aa2874a289849$exports = new URL("sampleimage2.01db026e.png", import.meta.url).toString();


var $d189c8723ceb0f64$exports = {};
$d189c8723ceb0f64$exports = new URL("solutionimage11.01cbdfe5.png", import.meta.url).toString();


var $5011e9457962bc87$exports = {};
$5011e9457962bc87$exports = new URL("solutionimage12.bf3a34c2.png", import.meta.url).toString();


var $06d8fe3f742e085b$exports = {};
$06d8fe3f742e085b$exports = new URL("solutionimage5.e15e4d12.png", import.meta.url).toString();


var $12530809dafdd2b3$exports = {};
$12530809dafdd2b3$exports = new URL("robogebra-og.397d41ee.png", import.meta.url).toString();


//navbar-overlay-menu
document.addEventListener("DOMContentLoaded", function() {
    const robogebraOGBanner1 = (0, (/*@__PURE__*/$parcel$interopDefault($12530809dafdd2b3$exports))); // TODO... Don't Remove
    const menuIcon = document.getElementById('menuIcon');
    if (menuIcon) menuIcon.addEventListener('click', toggleMenu);
    const overlayMenuIcon = document.getElementById('overlayMenu');
    if (overlayMenuIcon) overlayMenuIcon.addEventListener('click', onOverlayMenuClick);
    function toggleMenu() {
        overlayMenuIcon.classList.toggle('open');
        if (overlayMenuIcon.classList.contains('open')) {
            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.add('fa-times');
        } else {
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.add('fa-bars');
        }
    }
    function onOverlayMenuClick() {
        overlayMenuIcon.classList.toggle('open');
        menuIcon.classList.remove('fa-times');
        menuIcon.classList.add('fa-bars');
    }
});
//scroll-top-fuctionality
document.addEventListener("DOMContentLoaded", function() {
    const backToTopButton = document.getElementById("scrollTopBtn");
    if (backToTopButton) {
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > window.innerHeight) backToTopButton.style.display = "block";
            else backToTopButton.style.display = "none";
        });
        backToTopButton.addEventListener("click", ()=>{
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }
});
// --- Referral Source → Signup Redirect ---
document.addEventListener('DOMContentLoaded', function() {
    const signupBtn = document.getElementById('signupBtn');
    if (!signupBtn) return;
    const params = new URLSearchParams(window.location.search);
    const source = params.get('source');
    signupBtn.addEventListener('click', function() {
        const signupUrl = source ? `https://app.robogebra.ai/signup?source=${encodeURIComponent(source)}` : 'https://app.robogebra.ai/signup';
        window.open(signupUrl, '_blank', 'noopener,noreferrer');
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.abt-see-more-btn');
    buttons.forEach((button)=>{
        button.addEventListener('click', function() {
            const container = this.closest('.team-container');
            // Toggle expansion
            container.classList.toggle('expanded');
            // Optional: Toggle button text
            if (container.classList.contains('expanded')) this.textContent = 'See less...';
            else this.textContent = 'See more...';
        });
    });
    // Collapse when clicking outside
    document.addEventListener('click', function(event) {
        const expandedContainers = document.querySelectorAll('.team-container.expanded');
        expandedContainers.forEach((container)=>{
            if (!container.contains(event.target)) {
                container.classList.remove('expanded');
                // Reset the button text to "See more"
                const btn = container.querySelector('.abt-see-more-btn');
                if (btn) btn.textContent = 'See more...';
            }
        });
    });
});
// About-us section logic
document.addEventListener("DOMContentLoaded", ()=>{
    const topBio = document.getElementById("top-bio");
    const cards = document.querySelectorAll(".team-card");
    if (!topBio || cards.length === 0) return;
    // Attach click listeners to all cards
    cards.forEach((card)=>{
        card.addEventListener("click", ()=>{
            // Remove 'active' class from all cards
            cards.forEach((c)=>c.classList.remove("active"));
            // Add 'active' class to clicked card
            card.classList.add("active");
            // Show the bio
            const bio = card.getAttribute("data-bio");
            topBio.innerText = bio;
            topBio.classList.add("visible");
        });
    });
    // Select the first card by default
    cards[0].click();
});
// Audio Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    const audioPlayer = document.getElementById('audioPlayer');
    const playPauseBtn = document.getElementById('playPauseBtn');
    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = document.getElementById('progressFill');
    const progressThumb = document.getElementById('progressThumb');
    const progressBar = document.querySelector('.progress-bar');
    const currentTimeDisplay = document.getElementById('currentTime');
    if (!audioPlayer) return;
    let isDragging = false;
    // Format time helper function
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    // Update progress bar
    function updateProgress() {
        if (isDragging) return;
        const duration = audioPlayer.duration || 0;
        const currentTime = audioPlayer.currentTime || 0;
        const progressPercent = duration ? currentTime / duration * 100 : 0;
        progressFill.style.width = progressPercent + '%';
        progressThumb.style.left = progressPercent + '%';
        currentTimeDisplay.textContent = formatTime(currentTime);
    }
    // Play/Pause functionality
    playPauseBtn.addEventListener('click', function() {
        if (audioPlayer.paused) audioPlayer.play().then(()=>{
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
        }).catch((error)=>{
            console.error('Error playing audio:', error);
        });
        else {
            audioPlayer.pause();
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
    });
    // Progress bar click/drag functionality
    function updateAudioTime(event) {
        const progressBarRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressBarRect.left;
        const progressBarWidth = progressBarRect.width;
        const clickPercent = clickX / progressBarWidth * 100;
        const newTime = clickPercent / 100 * audioPlayer.duration;
        if (isFinite(newTime)) {
            audioPlayer.currentTime = newTime;
            updateProgress();
        }
    }
    progressBar.addEventListener('click', updateAudioTime);
    // Drag functionality for progress thumb
    progressThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
        if (isDragging) updateAudioTime(e);
    });
    document.addEventListener('mouseup', function() {
        isDragging = false;
    });
    // Audio event listeners
    audioPlayer.addEventListener('timeupdate', updateProgress);
    audioPlayer.addEventListener('loadedmetadata', function() {
        currentTimeDisplay.textContent = formatTime(0);
        updateProgress();
    });
    audioPlayer.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        progressFill.style.width = '0%';
        progressThumb.style.left = '0%';
        currentTimeDisplay.textContent = formatTime(0);
    });
    // Initialize display
    currentTimeDisplay.textContent = '03:00'; // Default duration as shown in image
});
// Coming Soon Modal Functions - Global scope
window.showComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
};
window.hideComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
};
// Close modal when clicking outside of it
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) modal.addEventListener('click', function(event) {
        if (event.target === modal) hideComingSoonModal();
    });
    // Load shared footer
    $e73bf42412feb220$var$loadSharedFooter();
});
// Shared Footer Component
function $e73bf42412feb220$var$loadSharedFooter() {
    const footerHTML = `
        <footer class="footer-container">
            <div class="container-xl">
                <div class="row py-md-5 justify-content-center">
                    <!-- Logo Section -->
                    <div class="col-md-4 col-sm-12 d-flex flex-column align-items-center justify-content-center footer-logo-section">
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($b3773c591ac0eb42$exports)))}" alt="Robogebra Logo" class="footer-logo-img">
                    </div>

                    <!-- Company Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px;" class="mb-0">Company</h5>
                        <ul class="list-unstyled mt-3 mb-0 ms-3">
                            <li class="mb-2"><a href="./index.html#pricing" style="color: #8B4B99; text-decoration: none;">Pricing</a></li>
                            <li class="mb-2"><a href="./about-us.html" style="color: #8B4B99; text-decoration: none;">About Us</a></li>
                            <li class="mb-2"><a href="./team.html" style="color: #8B4B99; text-decoration: none;">Team</a></li>
                            <li class="mb-2"><a href="./contact-us.html" style="color: #8B4B99; text-decoration: none;">Contact Us</a></li>
                            <li class="mb-2"><a href="https://app.robogebra.ai/login" target="_blank" style="color: #8B4B99; text-decoration: none;">Sign in</a></li>
                        </ul>
                    </div>

                    <!-- Connect with Us Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px; margin-left: 24px;" class="mb-0">Connect with Us</h5>
                        <ul class="list-unstyled mt-3  mb-0">
                            <li class="mb-2">
                                <a href="https://www.linkedin.com/company/robogebra-ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-linkedin" style="color: #8B4B99; margin-right: 8px;"></i>LinkedIn
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.youtube.com/@robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-youtube" style="color: #8B4B99; margin-right: 8px;"></i>YouTube
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.instagram.com/robogebra.ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-instagram" style="color: #8B4B99; margin-right: 8px;"></i>Instagram
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://x.com/robogebra_ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-x-twitter" style="color: #8B4B99; margin-right: 8px;"></i>X
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://robogebra.discourse.group/" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-discourse" style="color: #8B4B99; margin-right: 8px;"></i>Community
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Bottom Footer Bar -->
        <div class="bottom-footer-bar">
            <div class="container-xl">
                <div class="row py-3 align-items-center justify-content-center">
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Contact Us</strong>
                            <a href="mailto:support@robogebra.ai" style="color: #9ca3af; text-decoration: none;">support@robogebra.ai</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Legal</strong>
                            <a href="./terms.html" style="color: #9ca3af; text-decoration: none;">Terms of Service</a>
                            <span class="mx-2" style="color: #9ca3af;">|</span>
                            <a href="./policy.html" style="color: #9ca3af; text-decoration: none;">Privacy Policy</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;"><strong style="color: #fff;">Copyright</strong> \xa9 2025 Robogebra LLP</p>
                    </div>
                </div>
            </div>
        </div>
        
        
        <button id="scrollTopBtn" class="scroll-top-btn" style="cursor: pointer!important;">
            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($4cfeafcf552783b9$exports)))}" alt="scroll-icon" class="scroll-icon me-1">
            Go to Top
        </button>
    `;
    // Find existing footer and replace it, or add to end of body if no footer exists
    const existingFooter = document.querySelector('footer.footer-container');
    const existingScrollBtn = document.querySelector('#scrollTopBtn');
    const existingBottomFooter = document.querySelector('.bottom-footer-bar');
    if (existingFooter) {
        // Remove existing components
        existingFooter.remove();
        if (existingScrollBtn) existingScrollBtn.remove();
        if (existingBottomFooter) existingBottomFooter.remove();
    }
    // Add the new footer before the last script tag
    const scripts = document.querySelectorAll('script');
    const lastScript = scripts[scripts.length - 1];
    lastScript.insertAdjacentHTML('beforebegin', footerHTML);
    // Initialize scroll to top functionality
    $e73bf42412feb220$var$initializeScrollToTop();
}
// Initialize scroll to top functionality
function $e73bf42412feb220$var$initializeScrollToTop() {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (scrollTopBtn) {
        // Show/hide scroll button based on scroll position
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 300) scrollTopBtn.style.display = 'flex';
            else scrollTopBtn.style.display = 'none';
        });
        // Scroll to top when button is clicked
        scrollTopBtn.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
const $e73bf42412feb220$var$solutionData = [
    {
        id: 1,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ed4aa2874a289849$exports)))
    },
    {
        id: 2,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5011e9457962bc87$exports)))
    },
    {
        id: 3,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d189c8723ceb0f64$exports)))
    },
    {
        id: 4,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($06d8fe3f742e085b$exports)))
    }
];
const $e73bf42412feb220$var$solutionsGrid = document.getElementById('solutionsGrid');
const $e73bf42412feb220$var$modalOverlay = document.getElementById('modalOverlay');
const $e73bf42412feb220$var$modalImage = document.getElementById('modalImage');
const $e73bf42412feb220$var$modalClose = document.getElementById('modalClose');
function $e73bf42412feb220$var$createGridItems() {
    $e73bf42412feb220$var$solutionsGrid.innerHTML = '';
    $e73bf42412feb220$var$solutionData.forEach((solution)=>{
        const gridItem = document.createElement('div');
        gridItem.className = 'solution-item';
        gridItem.innerHTML = `
            <img class="solution-image" src="${solution.image}" loading="lazy">
            <div class="solution-overlay">
                <div class="zoom-icon">\u{1F50D}</div>
            </div>`;
        gridItem.addEventListener('click', ()=>{
            $e73bf42412feb220$var$openModal(solution);
        });
        const img = gridItem.querySelector('.solution-image');
        img.addEventListener('error', ()=>{
            img.style.color = 'white';
            img.style.display = 'flex';
            img.style.alignItems = 'center';
            img.style.justifyContent = 'center';
            img.style.fontSize = '1.2rem';
            img.style.fontWeight = '600';
            img.alt = 'Sample Solution';
        });
        $e73bf42412feb220$var$solutionsGrid.appendChild(gridItem);
    });
}
function $e73bf42412feb220$var$openModal(solution) {
    $e73bf42412feb220$var$modalImage.src = solution.image;
    $e73bf42412feb220$var$modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}
function $e73bf42412feb220$var$closeModal() {
    $e73bf42412feb220$var$modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}
$e73bf42412feb220$var$modalClose.addEventListener('click', $e73bf42412feb220$var$closeModal);
$e73bf42412feb220$var$modalOverlay.addEventListener('click', (e)=>{
    if (e.target === $e73bf42412feb220$var$modalOverlay) $e73bf42412feb220$var$closeModal();
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape' && $e73bf42412feb220$var$modalOverlay.classList.contains('active')) $e73bf42412feb220$var$closeModal();
});
document.addEventListener('DOMContentLoaded', ()=>{
    $e73bf42412feb220$var$createGridItems();
});


//# sourceMappingURL=index.4f25e4fc.js.map
